export default __webpack_public_path__ + "static/media/offer-drink.83297b25.jpg";